import { FieldError } from "client/lib/apt-merchant";

import { isValidEmail } from "../../../../../utils/validator";
import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

export class CustomerSupportEmailField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "helpYourselfFool@email.com",
      propertyName: "customerSupportEmail",
      uiFieldType: "Input",
      uiInputBaseProps: {
        inputMode: "email",
        autoCapitalize: "off",
        autoComplete: "email",
      },
      applicable: true,
      required: true,
      shown: true,
      ...opts,
    });
  }

  _validate(): void {
    if (typeof this.value === "undefined") return;

    if (!isValidEmail(this.value)) {
      throw new FieldError(this, "Must be a valid email", "InvalidEmail");
    }
  }
}
